import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class EnvironmentHelperService {
	constructor() {}

	public getCountryCodesForEnvironment() {
		switch (environment.env) {
			case 'local':
			case 'development':
			case 'production':
				return ['AU', 'NZ', 'PH'];
			case 'ushergroup':
				return ['AU'];
			case 'na':
				return ['CA', 'US'];
			case 'uk':
				return ['GB'];
			default:
				return ['AU', 'CA', 'GB', 'NZ', 'PH', 'US'];
		}
	}

	public getEnvironmentDefaultTimezone() {
		return environment.defaultTimezone;
	}

	public getEnvironmentDefaultLanguage() {
		switch (environment.env) {
			case 'na':
				return 'en-us';
			case 'uk':
				return 'en-uk';
			default:
				return 'en-au';
		}
	}
}
